module.exports = __webpack_public_path__ + "typing_user.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/typing_user.png
// module id = 2185
// module chunks = 13